
export const DATE = 'DATE'
export const NAME = 'NAME'
export const EVENT = 'EVENT'
